import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from 'component/utils/DatatableStyles'

const paginationOptions = {
    rowsPerPageText: "Show Per Page:", 
    rangeSeparatorText: "dari",
  };

const Datatables = ({data, onEditEmployee, onDeleteEmployee, onFetchEmployee }) => {
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("All");

    const handleSubmit = (e) => {
      e.preventDefault();
      onFetchEmployee(status);
    };

    const formattedData = data.map((item, index) => ({
      id: index + 1,
      ...item
    }));

    const filteredData = formattedData.filter((item) =>
      [item?.KARYAWAN_ID, item?.NAMA_LENGKAP]
        .some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))
    );
    console.log(filteredData)

    const columns = [
      { name: "No", selector: (row) => row.id, minWidth: '10px', style: { display: "flex", justifyContent: "center", alignItems: "center" } },
      { name: "Karyawan ID", selector: (row) => row.KARYAWAN_ID, minWidth: "100px", sortable: true },
      { name: "Nama", selector: (row) => row.NAMA_LENGKAP, minWidth: "120px", sortable: true },
      { name: "Tempat Lahir", selector: (row) => row.TEMPAT_LAHIR, minWidth: "80px", sortable: true },
      { name: "Tanggal Lahir", selector: (row) => row.TANGGAL_LAHIR, minWidth: "80px", sortable: true },
      { name: "JK", selector: (row) => row.JENIS_KELAMIN, minWidth: "10px", sortable: true, style: { display: "flex", justifyContent: "center", alignItems: "center" } },
      { name: "Pendidikan", selector: (row) => row.PENDIDIKAN, minWidth: "10px", sortable: true, style: { display: "flex", justifyContent: "center", alignItems: "center" } },
      { name: "Status", selector: (row) => row.STATUS_KARYAWAN, minWidth: "70px", sortable: true },
      { name: "Tgl Masuk", selector: (row) => row.TANGGAL_MASUK, minWidth: "80px", sortable: true },
      { name: "Tgl Keluar", selector: (row) => row.TANGGAL_KELUAR, minWidth: "80px", sortable: true },
      { name: "Jabatan", selector: (row) => row.JABATAN, minWidth: "80px", sortable: true },
      { name: "Divisi", selector: (row) => row.DEPARTEMEN, minWidth: "80px", sortable: true },
      { 
        name: "Action", 
        minWidth: "100px", 
        maxWidth: "250px", 
        style: { display: "flex", justifyContent: "center", alignItems: "center" },
        cell: (row) => (
          <div>
              <button 
                class="btn btn-sm rounded-circle btn-warning me-2" // Tambahkan margin agar tidak berdempetan
                onClick={() => onEditEmployee(row)}
              >
                <i class='bx bx-edit' style={{color:"white"}}></i>
              </button>
              <button 
                class="btn btn-sm rounded-circle btn-danger"
                onClick={() => onDeleteEmployee(row)}
              >
                <i class='bx bx-trash'></i>
              </button>
            </div>
        )
      }
    ];

    const customStylesOverride = {
      ...DatatableStyles,
      headCells: {
        ...DatatableStyles.headCells,
        style: {
          ...DatatableStyles.headCells.style,
          fontSize: "12px",
        },
      },
      cells: {
        ...DatatableStyles.cells,
        style: {
          ...DatatableStyles.cells.style,
          fontSize: "12px",
        },
      },
    };

  return (
    <div class="row">
      <div className="col-lg-12 m-4">
        <form onSubmit={handleSubmit}>
          <div className="row mb-1 align-items-center">
            <label className="col-sm-3 col-form-label col-form-label-sm">Pilih Status Karyawan</label>
            <div className="col-sm-3">
              <select 
                className="form-select form-select-sm" 
                value={status} 
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="All">All</option>
                <option value="Aktif">Aktif</option>
                <option value="Resign">Resign</option>
              </select>
            </div>
            <div className="col-sm-2">
              <button type="submit" className="btn btn-sm btn-success">Show</button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-lg-12 mb-4">
        <div class="d-flex justify-content-start align-items-center mb-2">
          <input
          type="text"
          placeholder="Search..."
          class="form-control w-100"
          style={{ maxWidth: "200px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div class="datatable-container">
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover={false}
            customStyles={customStylesOverride}
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 25]}
            paginationComponentOptions={paginationOptions}
            responsive
            />
        </div>
      </div>
    </div>
  );
};

export default Datatables;
